var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedInWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.2352 0.25177C5.49325 0.25177 0.0279999 5.71702 0.0279999 12.4589C0.0279999 19.2009 5.49325 24.6661 12.2352 24.6661C18.9771 24.6661 24.4423 19.2009 24.4423 12.4589C24.4423 5.71702 18.9771 0.25177 12.2352 0.25177ZM9.24696 17.5186H6.775V9.56355H9.24696V17.5186ZM7.99572 8.58698C7.21497 8.58698 6.71015 8.03384 6.71015 7.34973C6.71015 6.65163 7.23023 6.11503 8.02751 6.11503C8.82479 6.11503 9.31308 6.65163 9.32834 7.34973C9.32834 8.03384 8.82479 8.58698 7.99572 8.58698ZM18.2752 17.5186H15.8032V13.11C15.8032 12.0838 15.4446 11.387 14.5507 11.387C13.8679 11.387 13.4622 11.8588 13.283 12.3127C13.2168 12.4742 13.2003 12.7031 13.2003 12.9307V17.5173H10.7271V12.1004C10.7271 11.1073 10.6953 10.2769 10.6622 9.56228H12.8099L12.9231 10.6673H12.9727C13.2982 10.1485 14.0955 9.38299 15.4294 9.38299C17.0557 9.38299 18.2752 10.4727 18.2752 12.815V17.5186Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedInWhite);
export default __webpack_public_path__ + "static/media/LinkedIn-white.42545901a4a50c1d60c63ee9341cab15.svg";
export { ForwardRef as ReactComponent };